@let gridData = (model.state.gridData$ | async) || [];

<div [ngClass]="{ 'flex-grow-1': gridData.length === 0 }" class="table-wrapper">
  <app-data-grid
    (loadMoreClicked)="onLoadMoreClicked()"
    (sortUpdated)="onSortUpdated($event)"
    [columns]="(model.state.columns$ | async) ?? []"
    [data]="gridData"
    [isLoading]="(model.state.isPending$ | async) ?? false"
    [isLoadingMore]="(model.state.isLoadingNextPage$ | async) ?? false"
    [noDataAdditionalContentTemplate]="showAddUserButton ? addNewUserButton : undefined"
    [noDataDescription]="
      (model.isSearchOrFilterApplied
        ? 'search.no-data-description'
        : 'users.grid.no-data-description'
      ) | translate
    "
    [noDataIconTemplate]="
      model.isSearchOrFilterApplied ? gridEmptySearchIconTmpl : gridEmptyStateIconTmpl
    "
    [noDataTitle]="
      (model.isSearchOrFilterApplied ? 'search.no-data-title' : 'users.grid.no-data-title')
        | translate
    "
    [paginationEnabled]="(model.state.canLoadNextPage$ | async) ?? false"
    [sortOrder]="(model.state.gridSortOrder$ | async) || undefined"
    [templates]="{ favourite, user, lastActivity, loginAs, mfa }"
  ></app-data-grid>
</div>

<ng-template #favourite let-data="row">
  <span
    (click)="favouriteClicked.emit(data.user)"
    [class.pi-star-fill]="data.user.favourite"
    [class.pi-star]="!data.user.favourite"
    class="pi cursor-pointer"
  ></span>
</ng-template>

<ng-template #user let-data="row" let-profile>
  <div class="user-section flex">
    @if (data.lastActivity.type === 'invite') {
      <app-avatar [iconTemplate]="avatarIconTmpl" class="secondary"></app-avatar>
      <ng-template #avatarIconTmpl>
        <app-icon-clock color="var(--icon-color)"></app-icon-clock>
      </ng-template>
    } @else {
      <app-avatar [photo]="profile.photo"></app-avatar>
    }
    <div class="info-wrapper">
      <div class="name text-14" data-test-id="users.grid.name">{{ profile.name }}</div>
      <div class="email text-14" data-test-id="users.grid.email">
        @if (profile.email?.includes('@telematicsalerts.com')) {
          {{ profile.username }}
        } @else {
          {{ profile.email || profile.username }}
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #lastActivity let-activity let-data="row">
  <div class="activity-section flex">
    <div class="activity text-14">
      @switch (activity.type) {
        @case ('invite') {
          <span [class.not-allowed]="!canManage(data.user)">
            <p-tag
              (click)="canManage(data.user) ? userManager.resendInvitation(data.user) : undefined"
              [appCheckAccess]="sendInviteCheckAccess ?? [TYPES.Resource.User, TYPES.Action.Update]"
              [appTooltip]="'users.grid.resend-invite-msg' | translate"
              [tooltipPosition]="'bottom'"
              [value]="
                ('users.grid.invited-msg' | translate) +
                ' ' +
                (activity.date | formatDate: 'grid-date')
              "
              class="warning clickable"
            />
          </span>
        }
        @default {
          {{ activity.date | formatDate: 'grid-date' }}
        }
      }
    </div>
  </div>
</ng-template>

<ng-template #loginAs let-data="row">
  <div class="activity-section flex">
    <p-button
      (onClick)="loginAsClicked.emit(data.user)"
      [appCheckAccess]="loginAsAccessCheck"
      [disabled]="!data.user.isActive || !data.user.inviteAcceptedAt"
      [severity]="'secondary'"
      class="h--40 p--18 text-14 fw-600"
    >
      {{ 'users.grid.login-as-btn' | translate }}
    </p-button>
  </div>
</ng-template>

<ng-template #mfa let-data="row">
  <span [class.not-allowed]="data.mfa && !canManage(data.user)">
    <p-tag
      (click)="data.mfa && canManage(data.user) ? userManager.disableMfa(data.user) : undefined"
      [appCheckAccess]="disableMfaCheckAccess ?? [TYPES.Resource.User, TYPES.Action.Update]"
      [appTooltip]="data.mfa ? ('users.grid.mfa-disable-tooltip' | translate) : undefined"
      [class.clickable]="data.mfa"
      [class.success]="data.mfa"
      [class.warning]="!data.mfa"
      [tooltipPosition]="'top'"
      [value]="(data.mfa ? 'common.enabled' : 'common.disabled') | translate"
    />
  </span>
</ng-template>

<ng-template #gridEmptySearchIconTmpl>
  <app-icon-no-search></app-icon-no-search>
</ng-template>

<ng-template #addNewUserButton>
  <p-button
    (click)="addNewUserClicked.emit()"
    [appCheckAccess]="[TYPES.Resource.User, TYPES.Action.Create]"
    [severity]="'secondary'"
    class="text-14 fw-600 p--16 br--6 mt-24"
  >
    <app-icon-plus [color]="'var(--icon-color)'" [height]="20" [width]="20"></app-icon-plus>
    {{ 'users.grid.add-new' | translate }}
  </p-button>
</ng-template>

<ng-template #gridEmptyStateIconTmpl>
  <app-icon-no-users
    [color]="'var(--color-gray-900)'"
    [height]="32"
    [width]="32"
  ></app-icon-no-users>
</ng-template>
